<tvcore-ivv-title title="Ons aanbod"></tvcore-ivv-title>

<div class="grey-container u-m-top--md u-m-bottom--md">
	<p class="u-title u-title--line">{{ 'SHARE.TITLE' | translate }}</p>
</div>

@if (offers$ | async; as offers) {
	@if (offers.length) {
		<div class="c-cards-grid">
			@for (offer of offers; track offer.id) {
				<ivva-offer-card [fromShare]="true" [offer]="offer"></ivva-offer-card>
			}
		</div>
	}
}

<ivva-help></ivva-help>
